import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import { loadSystemConfigurations, selectSystemConfigurations } from '../store/systemConfigurations.reducer';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { SystemConfigurationsTableGrid } from '../Components/SystemConfigurationsTableGrid';

export const SystemConfigurations = () => {
    const dispatch = useAppDispatch();
    const systemConfigurations = useAppSelector(selectSystemConfigurations);

    useEffect(() => {
        dispatch(loadSystemConfigurations());
    }, []);

    return (
        <Box sx={{ width: '100%', height: '100%', p: 2, boxSizing: 'border-box' }}>
            {systemConfigurations && <SystemConfigurationsTableGrid configurations={systemConfigurations} />}
        </Box>
    );
};
